import {Flash, Link} from '@primer/react'

import styles from './InvalidCitationWarning.module.css'

export function InvalidCitationWarning({citationHelpUrl}: {citationHelpUrl: string}) {
  return (
    <Flash variant="warning" className={styles.Flash}>
      Your <strong>CITATION.cff</strong>file cannot be parsed. Make sure the formatting is correct.{' '}
      <Link inline href={citationHelpUrl}>
        Learn more about CITATION files.
      </Link>
    </Flash>
  )
}

try{ InvalidCitationWarning.displayName ||= 'InvalidCitationWarning' } catch {}